<template>
    <div id="loan_card_detail" class="mt-base mb-base loan-card-detail shadow-2">
        <div class="vx-col w-full">
            <img :src="icons[getIcon()]" svgClasses="w-3 h-3" class="cursor-pointer text-accent align-self-flex-center mb-6 w-10/12 h-48"/>
            <h4 class="mb-2 bold extra-bold">
                <slot name="title"></slot>
            </h4>
            <p class="mb-base">
                <slot name="desc"></slot>
                <small class="bold" v-if="showAllDocumentsCompletedNotif">
                    <br>
                    <br>Estamos revisando tu solicitud.
                </small>
            </p>
            
        </div>
        <vs-button v-if="hasLoans" @click.stop="requestLoan()" :color="hasLoan ? 'dark' : '#C8C8C8'" :class="hasLoan ? 'pulse-dark' : 'hover-primary'">
            {{ buttonText }}
        </vs-button>
        <vs-button v-else :disabled="!hasLocation" @click.stop="requestLoan()" color="dark" class="pulse-dark">
            {{ buttonText }} 
        </vs-button>
        <div class="mb-4">
            <small v-if="!hasLocation" class="danger">
                Para continuar, permite el acceso a tu ubicación
            </small>
        </div>
    </div>
</template>

<script>
export default {
    name: "LoanCardDetail",
    props: {
        loanType: String|Number,
        loan: Object,
        hasLoans: Boolean,
        hasLocation: Boolean
    },
    data: () => ({
        icons: {
            'CarIcon' : require("@assets/images/loan-onboarding/movilidad-icon.svg"),
            'SolarPanelIcon' : require("@assets/images/loan-onboarding/solar-icon.svg"),
            'PersonalIcon' : require("@assets/images/loan-onboarding/personal-icon.svg"),
            'PYMEIcon' : require("@assets/images/loan-onboarding/pyme-icon.svg")
        },
    }),
    computed: {
        hasLoan() {
            return this.loan != null;
        },
        loanId() {
            return this.loan != null ? this.loan.id : null;
        },
        buttonText() {
            let btnText = "Solicitar";
            if(this.hasLoan) { // Sí ya tiene solicitud
                if(this.loan.has_offer && this.loan.credit_acceptance_date != null) { // Sí tiene una oferta y no la aceptado.
                    btnText = "Continuar";
                } else if(this.loan.has_offer && this.loan.credit_acceptance_date == null)  {
                    btnText = "Ver oferta";
                } else {
                    btnText = "Continuar";
                }
            }

            return btnText;
        },
        showAllDocumentsCompletedNotif() {
            if(this.hasLoan) {
                return this.loan.documentation_complete_date != null;
            } else {
                return false;
            }
        },
        isPF() {
            return this.UserPersonType == 1 || this.UserPersonType == 2;
        },
    },
    methods: {
        async requestLoan() {
            if(this.loanId != null) {
                await this.$router.replace({name: 'applicantLoanDetail', params: { id: this.loanId }});
            } else {
                // Sí es un PYME y es PF, avisar que le van a pedir syntage.
                if(this.loanType == 3 && this.isPF) {
                    this.$vs.dialog({
                        type: 'confirm',
                        color: 'warning',
                        title: 'Solicitar Crédito PYME',
                        text: `Para poder solicitar este crédito es necesario que cuentes con el régimen de <<Persona Física con Actividad Empresarial>>, ya que más adelante se validará que cuentes con dicho régimen fiscal.`,
                        acceptText: "Continuar",
                        cancelText: 'Cancelar',
                        accept: this.doStartLoanRequest
                    });
                } else {
                    await this.$router.replace({name: 'loanRequest', params: { loanTypeProp: this.loanType }});
                }
            }
        },
        async doStartLoanRequest()
        {
            await this.$router.replace({name: 'loanRequest', params: { loanTypeProp: this.loanType }});
        },
        getIcon() {
            let icon = "";
            if(this.loanType == 1) {
                icon = 'SolarPanelIcon';
            } else if(this.loanType == 2) {
                icon = 'CarIcon';
            } else if(this.loanType == 4) {
                icon = "PersonalIcon";
            } else if(this.loanType == 3) {
                icon = "PYMEIcon";
            }

            return icon;
        }
    }
}
</script>

<style>
.loan-card-detail {
    /* border: 2px solid #C8C8C8; */
    border-radius: 10px;
    padding: 3rem 3.5rem 4rem 3.5rem;
    text-align: center;
    text-align: -webkit-center;
    min-height: 90%;
    position: relative;
}

.loan-card-detail button {
    position: absolute;
    bottom: 7% ;
    transform: translate(-50%, -50%);
}

.loan-card-detail small {
    position: absolute;
    transform: translate(-50%, -50%);
    bottom: 8px;
    line-height: 10px;
    color: #707c92;
}

.hover-primary {
    color: #fff;
}

.hover-primary:hover {
    background-color: #3b3a3e !important;
    color: white !important;

}
</style>